import { combineReducers } from "redux";
import { branchesEntriesReducer } from "modules/Branches/services/Branches/reducer";

export const branchesReducer = combineReducers({ entries: branchesEntriesReducer });